// extracted by mini-css-extract-plugin
export default {"root":"footer_root__zd1K1","content":"footer_content__PmVua"};